# Backbone views

window.aqnz ?= {}
aqnz.View ?= {}
{Model, View} = aqnz

Collection = aqnz.Collection  # Used for sectionCollection.  TODO extract to model

# TODO: subclass view that accepts obj instead of Backbone.Model

#----------------------------------------------------------#
#  Checklist
#----------------------------------------------------------#

class View.Checklist extends Backbone.View
  
  initialize: ->
    
    {@species, @checklistId, @industryStatistics, @sectionCollection, @files} = @model.attributes
    
    new View.ReportTotals {@species, @industryStatistics}
    
    @sectionCollection.each (section) =>
      model = new Backbone.Model {section, @files}
      new View.Section {@el, model}
      
    new View.ChecklistProgress
      el: $ ".checklist-progress"
      model: new Backbone.Model {@checklistId, @sectionCollection}
    
    new View.ChecklistQuestionFilters
    
    @model.on "change:updated", =>
      $(".checklist-updated-date").html(@model.get "updated")
      $(".saved-status").show().fadeOut(1000)
    
  questionFilters: ->
  


class View.ReportTotals
  
  constructor: (@spec) ->
    
    {@species, @industryStatistics} = @spec
    
    return unless @industryStatistics
    s = @industryStatistics
    
    numGrowers = s.numGrowers
    numFarms = numberFormat(s.numFarms)
    haConsented = numberFormat(Math.round s.hectaresConsented)
    
    haAnswered = if s.answeredHectares<0.01 then (100*s.answeredHectares).toPrecision(1) else Math.round(100*s.answeredHectares)
    utilisation = if s.utilisation is null then "0" else Math.round(100*s.utilisation)
    haFarmed = numberFormat(Math.round s.hectaresFarmed)
    
    productionAnswered = if s.answeredProduction<0.01
      (100*s.answeredProduction).toPrecision(1)
    else
      Math.round(100*s.answeredProduction)
    production = numberFormat(Math.round s.production)
    productionUnits = s.productionUnits
    
    template = _.tmpl "#industry-statistics-tmpl"
    
    $(".report-totals").html(template {
      @species
      numGrowers
      numFarms
      haConsented
      
      haAnswered
      utilisation
      haFarmed
      
      productionAnswered 
      production
      productionUnits
    })
  


class View.QuestionHelp
  
  constructor: ->
    @button = $ ".show-question-help"
    @guides = $ ".question-help"
    @visible = true
    @show @visible
    @button.click => @show(not @visible)
    @button.hide() if @guides.length is 0

    # Images - add click method
    images = @guides.find("img.checklist-image")
    @configImage($(image)) for image in images
    
  show: (@visible=true) ->
    text = "#{if @visible then "Hide" else "Show"} question help"
    @button.text text
    @guides[if @visible then "show" else "hide"]()
    @guides[if @visible then "addClass" else "removeClass"](".question-help-print")

  configImage: (image) ->
      src = image.src
      image.after("<br><i>Click image to zoom/enlarge</i>")
      image.click(=> image.toggleClass("image-large"))
      # $(image).click(=> window.open(src, 'checklist-image'))

class View.HelpButton
  
  constructor: (@container, @name) ->
    @button = @container.find ".fa-question-circle"
    @help = @container.find ".question-help" 
    @button.attr "title", "View help for this #{@name}"
    @button.click => @help.toggle()
  


class View.ChecklistProgress extends Backbone.View
  
  iconTemplate: _.tmpl "#section-icon-tmpl"
  progressTemplate: _.tmpl "#section-progress-tmpl"
  progressTemplateBoxLinks: _.tmpl "#section-progress-box-links-tmpl"
  
  initialize: ->
    {@checklistId, @sectionCollection} = @model.attributes
    @render()
    @sectionCollection.on "changedAnswer", => @render()
    
    @buttonShowAllSections = $ ".button-show-all-sections"
    $(@buttonShowAllSections).click => @showSections()
  
  render: ->
    sections = @sectionCollection.mainAnswerSummary()
    
    @$el.empty()
    
    for section in sections
      {iconClass} = section 
      @$el.append(@iconTemplate {iconClass})
    
    @$el.append "<br>"  # TODO: template
    
    boxLinks = @$el.data "box-links"  # Used for growers list; non-interactive progress boxes
    template = if boxLinks then @progressTemplateBoxLinks else @progressTemplate
    
    for section in sections
      {name, iconClass, numAnswered, numToAnswer} = section 
      {percent, percentClass, progressDescription, boxChar} = @progress numAnswered, numToAnswer
      id = @checklistId
      anchor = name.replace " ", "_"
      progressBox = $ template {id, name, anchor, progressDescription, percentClass, boxChar}
      @setClick progressBox, name
      @$el.append(progressBox)
  
  setClick: (progressBox, name) ->
    square = progressBox.find ".square"
    progressBox.click =>
      @showSections name
      square.addClass "square-highlighted"
  
  showSections: (name=null) ->
    @unhighlightBoxes()
    @buttonShowAllSections[if name then "fadeIn" else "fadeOut"](300)
    @sectionCollection.showMain name
  
  unhighlightBoxes: ->
    squares = $(".progress-box-anchor").find ".square"
    squares.removeClass "square-highlighted"
  
  progress: (numAnswered, numToAnswer) ->
    # TODO: in model?  helper?
    p = Math.round(100*numAnswered/numToAnswer)
    q = if p is 100 then "100" else (if p>=50 then "50" else (if p>0 then "1" else "0"))
    #console.log "progress", numAnswered, numToAnswer, p, q
    boxChar = if p>0 and p<100 then p+"%" else (if p is 0 then "&nbsp;" else "&#10003;")
    progress =
      percent: p
      percentClass: "completed-#{q}"
      progressDescription: "#{numAnswered} of #{numToAnswer} question#{if numToAnswer>1 then "s" else ""} answered (#{p}%)"
      boxChar: boxChar


class View.ChecklistProgressOverall extends Backbone.View
  
  checkMarkSel: ".check-mark"
  progressTextSel: ".checklist-progress-overall-text"
  fadeCheckMarkClass: "fade-check-mark"
  loadingSel: ".loading"
  
  initialize: ->
    {@answerSummary, @sectionCollection} = @model.attributes
    
    @checkMark = @$el.find @checkMarkSel
    @progressText = @$el.find @progressTextSel
    @loading = @$el.find @loadingSel
    
    @growerInfo = $ ".grower-info"
    
    @render()
    @sectionCollection.on "changedAnswer", => @render()
    
  # Dup code - see aqua
  setHash: (hash=null) ->
    growerContainer = $ ".container-grower-detail"
    unless hash
      ids = ($(container).data("grower") for container in growerContainer.filter(':visible'))
      hash = ids.join ","
      
    if history.pushState
      history.pushState null, null, '#'+hash
    else
      window.location.hash = hash
  
  render: ->
    
    progress = @answerSummary.progress @sectionCollection
    
    @loading.remove()
    @checkMark.show()
    
    if progress is 0
      @checkMark.addClass @fadeCheckMarkClass
      @checkMark.attr title: "No checklist questions answered"
    else
      pText = progress + "%"
      pTitle = "#{pText} of checklist questions answered"
      @checkMark.attr title: pTitle
      @progressText.attr title: pTitle
      @progressText.text pText
  


class View.ChecklistQuestionFilters
  
  constructor: ->
    return
    $('.checklist-key div').click (evt) =>
      button = $(evt.target)
      # console.log
      # x = button.attr "class" #("key-to-answer")
      # x = x.split(' ')
      # console.log x
      # y = $(".key-to-answer")
      # y.css
      #   borderLeft: "1px solid black"
      #   borderTop: "1px solid black"
      #   borderBottom: "1px solid black"
      #
      # console.log y
      # $(".questions").hide()
      # $(".questions.disabled-question").show()  # unanswered, answered, optional, disabled
      # $(".answer-analysis").closest(".row").hide()


class View.IndustryChecklistsReport
  
  constructor: (@model) ->
    
    @renderReportLinks()
    @renderProduction()
    
    new View.YearButtons {@model}
    
    @model.on "setAnswerSummary", =>
      $(".checklist-completion-loading").hide()
      $(".checklist-completion").removeClass("hide")
      @renderProgress()
    
    @model.onSet "year", =>
      @renderReportLinks()
      @renderProduction()
      @renderProgress()
  
  renderReportLinks: ->
    year = @model.year
    for species in @model.species
      link = $ ".checklist-report-link a[data-species='#{species}']"
      nickname = link.data "speciesNickname"
      link.attr "href", "/grower-checklist/report/#{year}/#{nickname}"
  
  renderProduction: ->
    year = @model.year
    for species in @model.species
      production = @model.production(species)
      productionFormatted = if species is "OYS" then dozens(production) else tonnes(production)
      $(".production[data-species='#{species}']").html(productionFormatted)
      $(".production-completed[data-species='#{species}']").html("&nbsp;")
  
  renderProgress: ->
    year = @model.year
    for species, checklists of @model.checklists[year]
      for f, c of checklists
        if f is "volumeProduced"
          production = @model.production(species)
          completed = if production>0 then Math.round(100*c.completed/production) else 0
          $(".production-completed[data-species='#{species}']").html "#{completed}% completed"
        else
          @setBox(species, f, "checklists-completed", c.completed)
          @setBox(species, f, "checklists-started", c.started)
          @setBox(species, f, "checklists-not-started", c.notStarted)
    
  
  setBox: (species, f, c, x) ->
    div = $ "div.#{c}[data-species='#{species}'][data-region='#{f}']"
    div[if x then "removeClass" else "addClass"]("checklists-no-progress")
    div.html(if x then x else "&nbsp;")
  


class View.YearButtons
  
  constructor: (@spec)->
    
    {@model} = @spec
    
    @buttons = $ ".year-button"
    @setButtons()
    
    @buttons.click (evt) =>
      b = $(evt.target)
      @model.set "year", b.data("year")
    
    @model.onSet "year", => @setButtons()
      
  setButtons: ->
    for button in @buttons
      b = $(button)
      highlight = b.data("year").toString() is @model.year.toString()
      b[if highlight then "addClass" else "removeClass"] "active"
  


#----------------------------------------------------------#
#  Sections
#----------------------------------------------------------#

class View.Section extends Backbone.View
  
  mainSectionClass: "main-section"
    
  initialize: ->
    
    {@section} = @model.attributes
    {@main, @questionCollection} = @section.attributes  # TODO: Needed?
    
    main = @section.isMain()
    
    if main
      @mainSection()
    else
      @subsection()
    
    @show(@section.get("visible"), false)
    @section.on "change:visible", => @show(@section.get "visible")
    
  mainSection: ->
    el = @$el
    
    @heading = new View.SectionMainHeading {el, model: @section}
    
    el = $("<div>", class: @mainSectionClass).appendTo(@$el)
    @sectionEl = el
    
    name = @section.get "name"
    el.attr("id", name) if name
    
    new View.SectionQuestions {el, @model}
    
  subsection: ->
    el = @$el.find(".#{@mainSectionClass}").last()
    @sectionEl = el
    new View.SectionQuestions {el, @model}  # Heading is inserted here
    
  show: (show=true, setArrow=true) ->
    @sectionEl[if show then "show" else "hide"]()
    @heading?.setArrow(show) if setArrow
    


class View.SectionMainHeading extends Backbone.View
  
  template: _.tmpl "#checklist-section-heading-tmpl"
  
  mainSectionSel: ".main-section"
  
  initialize: ->
    {section, number, name, main, guide, iconClass, questionCollection} = @model.attributes
    return unless name
    
    id = name.replace(" ", "_")
    @heading = $ @template {section, number, name, id, iconClass, guide}
    @$el.append @heading
    
    @model.on "change:visible", => @show(@model.get "visible")
    
    new View.HelpButton @heading, "section"
      
  setArrow: (show=true) ->
    
    return unless @heading?.length
    
    arrow = @heading.find ".section-arrow"
    up = "fa-angle-up"
    down = "fa-angle-down"
    
    arrow.removeClass(up)
    arrow.removeClass(down)
    arrow.addClass(if show then up else down)
    
  show: (show=true) ->
    @heading[if show then "show" else "hide"]()
    #@setArrow(show) if setArrow


class View.SectionQuestions extends Backbone.View
  
  template: _.tmpl "#checklist-questions-form-tmpl"
  subheadingTemplate: _.tmpl "#checklist-subsection-heading-tmpl"
  
  questionClasses: ->
    'yes-no': View.YesNoQuestion
    text: View.TextQuestion
    "number-grower": View.GrowerNumberQuestion
    number: View.RegionalNumberQuestion  # Regional
    file: View.FileQuestion
  
  initialize: ->
    {@section, @files} = @model.attributes
    @questions = @section.get "questionCollection"
    return unless @questions.length
    @form = $ @template()
    # Alt: onkeydown="return event.key != 'Enter'"
    @form.submit => false  # To prevent submitting form and reloading page
    @$el.append @form
    
    # Append subheading to form if not a main section
    # This keeps subsection together (with subheading) for printing.
    @renderSubheading() unless @section.isMain()
    
    @questions.each (question) => @renderQuestion(question)
  
  renderSubheading: ->
    
    name = @section.get "name"
    guide = @section.get "guide"
    
    subheading = $ @subheadingTemplate {name, guide}
    
    @form.append subheading
    
    new View.HelpButton subheading, "section"
    
  renderQuestion: (question) ->
    
    type = question.get "type"
    
    QuestionClass = @questionClasses()[type]
    unless QuestionClass
      console.log "Unknown question type"
      return
    
    questionView = new QuestionClass
      el: @form
      model: new Backbone.Model {question, @files}


#----------------------------------------------------------#
#  Questions
#----------------------------------------------------------#


class View.Question extends Backbone.View
  
  industryAnalysisClass: -> View.AnswerAnalysis
  userAnalysisClass: -> View.AnswerAnalysis
  
  customIndustryReportClasses: -> null  # Override in subclass
  customUserReportClasses: -> null  # Override in subclass
    
  growerAnswersClass: -> View.GrowerAnswers
  
  saveOkClass: "edit-field-save-ok"
  
  analysisColSel: ".answer-analysis-column"
  
  helpTemplate: _.tmpl "#checklist-question-help-tmpl"
    
  initialize: ->

    # TODO TEMP
    @growerId = aqnz.growerId
    @awsFolder = aqnz.awsFolder
    
    {@question, @files} = @model.attributes
    {@qId, @qNumber, @text, @type, @na, @guide, @evidence, @level, @subqDefault, @answerModel, @report, @growerAnswers, @notScored} = @question.attributes

    @initUnsavedChangesHandler()
    
    @init()  # Subclass method
      
    if @qId is ""
      alert "Error - no id: "+@text
    
    @setEnabledState()
    @setAnsweredState()
    @question.on "change:enabled", =>
      @setEnabledState()
      @setAnsweredState()
    @question.on "changedAnswer", => @setAnsweredState()
    
    new View.Guide
      el: @questionEl.find ".question-help-area"
      model: new Backbone.Model {@guide, @evidence}
    
    new View.HelpButton @questionEl, "question"
    
    @subquestions()
    
    @analysisCol = @questionEl.find(@analysisColSel)
    analysis = @answerAnalysis()
    
    @growerAnswersButton(analysis.answersButtonContainer()) if analysis
    @growerAnswersList()

    @initFiles()
  
  initFiles: ->

    @fileCollection = @answerModel.get "fileCollection"
    @filesEl = @questionEl.find ".files-area"
    return unless @filesEl.length

    @fileChecklist = new View.FileChecklist
      el: @filesEl
      model: new Backbone.Model {@qId, @answerModel, @fileCollection}

    # @selectLastYearEl = @filesEl.find ".select-files-last-year"
    
    # if @fileChecklist.checkedBoxes().length
    #   @selectLastYearEl.hide()
    # else
    #   @selectLastYearEl.click =>
    #     @selectLastYearEl.hide()
    #     @fileChecklist.selectLastYear()  # TODO via model?

  answer: -> @answerModel.get "answer"
  
  notes: -> @answerModel.get "notes"

  saveAnswer: (el, answer) ->
    @answerModel.saveAnswer answer, (data) => @saved el, data

  saveNotes: (el, notes) ->
    @answerModel.saveNotes notes, (data) => @savedNotes el, data
  
  saved: (el, data) ->
    ok = data.ok
    unless data.ok
      console.log "Not saved"
      return
    @dirty = false
    @flash el, true

  savedNotes: (el, data) ->
    ok = data.ok
    unless data.ok
      console.log "Not saved"
      return
    # TODO @dirty = false
    @flash el, true
  
  setEnabledState: ->
    show = @question.get "enabled"
    @questionEl.removeClass "disabled-question"
    @questionEl.addClass "disabled-question" unless show
    #@questionEl.css opacity: (if show then 1 else 0.5)
    
    for element in ["input", ".select-files-button", "textarea"]
      el = @questionEl.find(element)
      el.attr(disabled: not(show)) if aqnz.canTouch
      
  setAnsweredState: ->
    answeredCls = "answered-question"
    unansweredCls = "unanswered-question"
    {answered, yetToAnswer} = @question.answerSummary()
    @questionEl.removeClass(answeredCls)
    @questionEl.removeClass(unansweredCls)
    @questionEl.addClass(answeredCls) if answered
    @questionEl.addClass(unansweredCls) if yetToAnswer
    
  initUnsavedChangesHandler: ->
    
    @dirtyEvents = "keyup paste"
    
    @dirty = false
    
    window.addEventListener "beforeunload", (e) =>
      
      async = false
      
      if @dirty
        {answer} = @dirty
        saved = @answerModel.saveAnswer answer, null, async
        unless saved
          console.log "NOT SAVED"
          return
        @dirty = false
        console.log "SAVED"
      
      undefined
  
  # TODO: put in superclass for all views?
  
  flash: (el, flash) ->
    saveOkClass = @saveOkClass
    if el.attr("type") is "radio"
      el = el.closest("label").find(".checkmark")
      saveOkClass += " radio-button-save-ok"
    el.addClass(saveOkClass).removeClass(saveOkClass, {duration: 1000}) if flash
  
  subquestions: ->
    new View.Subquestions
      el: @questionEl
      model: new Backbone.Model {@question}
  
  answerAnalysis: ->
    # If grower answers available, use admin analysis/report; else user analysis
    analysisClass = if @growerAnswers then @industryAnalysisClass else @userAnalysisClass
    customReportClasses = if @growerAnswers then @customIndustryReportClasses else @customUserReportClasses
    AnalysisClass = customReportClasses()?[@report] ? analysisClass()
    
    return null unless @analysisCol.length
    
    new AnalysisClass
      el:  @analysisCol
      model: @question
  
  
  growerAnswersButton: (el) ->
    return unless el
    new View.GrowerAnswersButton
      el: el
      model: @question
  
  
  growerAnswersList: ->
    AnswersClass = @growerAnswersClass()
    new AnswersClass
      el:  @analysisCol
      model: @question


class View.YesNoQuestion extends View.Question
  
  template: _.tmpl "#checklist-yes-no-question-tmpl"
  
  industryAnalysisClass: -> View.IndustryYesNoAnalysis
  userAnalysisClass: -> View.UserYesNoAnalysis
  
  growerAnswersClass: -> View.YesNoAnswers
  
  init: ->
    
    cls =
      y: "user-answer-y"
      n: "user-answer-n"
      na: "user-answer-na"
      
    {@transpose} = @question.attributes

    answerPrevYear = @question.answerPrevYear()
    answerTextPrevYear = ({"yes": "Yes", "no": "No", "n/a": "n/a"}[answerPrevYear] if answerPrevYear) ? ""
    fileIdsPrevYear = @question.fileIdsPrevYear()
    numFilesPrevYear = fileIdsPrevYear.length
    
    @questionEl = $ @template {@qId, @qNumber, @text, @type, @level, @na, @growerId, @awsFolder, @guide, @evidence, @transpose, @notScored, answerPrevYear, answerTextPrevYear, numFilesPrevYear, cls}  # template is subclass property
    @$el.append @questionEl
    
    @radioButtons = @questionEl.find "input"
    
    # @radioButtons.attr("disabled", true) unless aqnz.canTouch  Stay enabled so shows as blue
    
    answer = @answer()
    @radioButtons.filter("[value='#{answer}']").attr(checked: true) if answer
    
    @radioButtons.click (evt) =>
      button = $ evt.target
      previous = @answer()
      answer = button.val()
      if answer is previous
        # Clear answer if same as previous
        button.prop "checked", false
        answer = ""
      @saveAnswer button, answer

    @notesBox = @questionEl.find ".form-control.checklist-notes-edit-box"
    @notesBox.attr "readonly", (not aqnz.canTouch)

    notes = @notes()
    @notesBox.val(notes) if notes

    @notesBox.change (evt) =>
      val = @notesBox.val()
      @saveNotes(@notesBox, val)
      @setNotesRows()

    @setNotesRows()

  setNotesRows: ->
    @notesBox.height 0
    h = @notesBox.prop "scrollHeight"
    @notesBox.height(h)


class View.TextQuestion extends View.Question
  
  template: _.tmpl "#checklist-text-question-tmpl"
  
  init: ->
    @questionEl = $ @template {@qId, @qNumber, @text, @type, @level, @guide, @evidence}  # template is subclass property
    @$el.append @questionEl
    @editBox = @questionEl.find ".form-control.checklist-edit-box"
    
    @editBox.attr "readonly", (not aqnz.canTouch)
    
    answer = @answer()
    @editBox.val(answer) if answer
    
    # @editBox.keyup (evt) =>
    
    @editBox.change (evt) =>
      val = @editBox.val()
      @saveAnswer(@editBox, val)
      @setRows()
    
    @editBox.bind @dirtyEvents, (evt) =>
      @dirty = {answer: @editBox.val()}

    @setRows()
  
  setRows: ->
    @editBox.height 0
    h = @editBox.prop "scrollHeight"
    @editBox.height h
    
  setRowsBasedOnTextLines: ->
    # Old approach
    currentNumRows = @editBox.attr "rows"
    val = @editBox.val()
    rows = val?.split "\n"
    numRows = rows?.length ? 0
    numRows = 1 if numRows<1
    @editBox.attr("rows", numRows) if numRows isnt currentNumRows
    



class View.GrowerNumberQuestion extends View.Question
  
  template: _.tmpl "#checklist-grower-number-question-tmpl"
  
  industryAnalysisClass: -> View.GrowerNumberAnalysis
  userAnalysisClass: -> View.GrowerNumberAnalysis
  
  init: ->
    
    @hectaresNote()
    
    @questionEl = $ @template {@qId, @qNumber, @text, @type, @level, @guide, @evidence, @notScored}  # template is subclass property
    @$el.append @questionEl
    
    @editBox = @questionEl.find ".form-control.checklist-edit-box"
    
    @editBox.attr "readonly", (not aqnz.canTouch)
    
    answer = @answer()
    @editBox.val(answer) if answer
    
    @editBox.change (evt) =>
      box = $ evt.target
      answer = box.val()
      @saveAnswer box, answer
    
    @editBox.bind @dirtyEvents, (evt) =>
      box = $ evt.target
      @dirty = {answer: @processChange(box)}
  
  processChange: (box) ->
    answer = box.val()
    @answerModel.set "answer", answer
    answer
  
  hectaresNote: ->
    ha = @question.get "hectaresConsented"
    return unless ha
    unit = "hectare" + (if ha is 1 then "" else "s")
    @text += "<br>(out of #{ha.toFixed(1)} #{unit} consented)"


class View.RegionalNumberQuestion extends View.Question
  
  template: _.tmpl "#checklist-regional-number-question-tmpl"
  
  industryAnalysisClass: -> View.GrowerNumberAnalysis  #View.RegionalNumberAnalysis
  userAnalysisClass: -> View.GrowerNumberAnalysis #View.RegionalNumberAnalysis
  
  customIndustryReportClasses: ->
    # "clean_up": View.IndustryCleanupReport
    
  customUserReportClasses: ->
    # "clean_up": View.UserCleanupReport
  
  growerAnswersClass: -> View.RegionalNumberAnswers
  
  init: ->
    
    @regions = @answerModel.get "regions"
    
    @questionEl = $ @template {@qId, @qNumber, @text, @type, @level, @regions, @guide, @evidence, @notScored}  # template is subclass property
    @$el.append @questionEl
    @editBox = @questionEl.find ".form-control.checklist-edit-box"
    
    @editBox.attr "readonly", (not aqnz.canTouch)
    
    @editBox.change (evt) =>
      box = $ evt.target
      @saveAnswer box, @processChange(box)
    
    @editBox.bind @dirtyEvents, (evt) =>
      box = $ evt.target
      @dirty = {answer: @processChange(box)}
      
  processChange: (box) ->
    regionName = box.data "regionName"  # TODO: use region id?
    answer = box.val()
    @answerModel.setRegionAnswer answer, regionName


class View.FileQuestion extends View.Question
  
  template: _.tmpl "#checklist-file-question-tmpl"
  
  growerAnswersClass: -> View.FileAnswers
  
  init: ->
    
    # TODO TEMP
    growerId = aqnz.growerId
    awsFolder = aqnz.awsFolder
    
    @questionEl = $ @template {@qId, @text, @type, @level, growerId, awsFolder, @guide}
    @$el.append @questionEl
    
    {@fileCollection} = @answerModel.attributes
    new View.FileChecklist
      el: @questionEl
      model: new Backbone.Model {@qId, @answerModel, @fileCollection}


class View.Guide extends Backbone.View
  
  template: _.tmpl "#checklist-question-help-tmpl"
  
  initialize: ->
    {@guide, @evidence} = @model.attributes
    return unless @$el.length
    @$el.append(@template {@guide, @evidence})
  

#----------------------------------------------------------#
#  Subquestions for Yes/No answers
#----------------------------------------------------------#

class View.Subquestions extends Backbone.View
  
  yesNoButtonSel: '.form-check-input'
  buttonSel: ".subanswer-button"
  subanswerSel: ".subanswers"
  
  initialize: ->
    
    {@question} = @model.attributes
    {@level, @answerModel} = @question.attributes
    
    return if @level is "grower"
    # TODO: also return if not yes-no question?  Invoke View only if yes-no?
    # TODO: handle subq enable?
    
    @listEl = @$el.find @subanswerSel
    
    if @level in ["farm", "area"]
      #      @showAreaCollection() if @level is "area"  # Temp feature to show old area collection answers
      new View.FarmList
        el: @listEl
        model: @answerModel
    else
      console.log "Unknown question level"
    
    collection = @answerModel.get "subquestionCollection"
    
    @numItems = collection?.length
    numApplies = => collection?.numApplies()
    
    @areaNumItems =  @areaCollection?.length
    areaNumApplies = => @areaCollection?.numApplies()
    
    new View.SubanswerButton
      el: @$el.find(@buttonSel)
      model: new Backbone.Model {@question, @numItems, numApplies, @areaNumItems, areaNumApplies}
    
  showAreaCollection: ->
    
    @areaCollection = @answerModel.get "areaSubquestionCollection"
    
    l = $("<div class='col-sm-offset-1 col-sm-11'>").appendTo("<div class='row subanswers-row'>").appendTo(@listEl)
        
    l.append "<b>Previous areas deselected</b><br>"
    any = false
    @areaCollection?.each (model) =>
      region = model.get("region").name
      area = model.get("area").name
      applies = model.get("subanswer").get("applies")
      return if applies
      any = true
      qText = @question.get "text"
      #console.log qText, area
      l.append "#{region}, #{area}<br>"
      
    unless any
      l.append "None<br>"


class View.SubanswerButton extends Backbone.View
  
  classes:
    select: "select-farms"
    num: "num-farms"
    percent: "percent-farms"
    all: "all-farms"
  
  initialize: ->
    
    {@question, @numItems, @numApplies, @areaNumItems, @areaNumApplies} = @model.attributes
    {@qId, @level, @subqDefault, @answerModel} = @question.attributes
    
    @unit = "farm" #@level
    @set()
    
    @$el.click =>
      enabled = @answerModel.get "subquestionsEnabled"
      enabled = not(enabled)  # Toggle
      @answerModel.set "subquestionsEnabled", enabled
      @arrow()
      false
    
    # @answerModel.on "change:answer", =>
    #   @$el.show()
    #   @$el.html ""
    
    @answerModel.on "answerReady", =>
      @set() #unless @answerModel.get("queueSubanswer")?
    
    @answerModel.onChangeSubanswer (s) => @set()
    
  set: ->
    subEnable = "yes"  # Later, could be an option
    answer = @answerModel.get "answer"
    enable = answer is subEnable
    
    n = @numApplies()
    m = @numItems
    
    c = ""
    if n>0
      if n<m
        if m<=10 or n<m/2
          text = n + " farm" + (if n>1 then "s" else "")
          c = @classes.num
        else
          percent = Math.round(100*n/m)
          text = percent + "% farms"
          c = @classes.percent
      else
        if m>1
          text = "All farms"
          c = @classes.all
        else
          return
    else
      if m>1
        text = "Select farms"
        c = @classes.select
      else
        return
      
    # if @areaNumItems and @areaNumApplies()<@areaNumItems
    #   text += " <span style='color:red; font-size:14pt;'>&starf;</span>"
    
    @$el[if enable then "show" else "hide"]()
    @$el.find(".subanswer-button-text").html text
    @$el.removeClass @vals(@classes).join(" ")  #Object.values(@classes).join(" ")
    @$el.addClass c
    @arrow()
    
  vals: (obj) ->
    Object.keys(obj).map (key) -> obj[key]
    
  arrow: ->
    enabled = @answerModel.get "subquestionsEnabled"
    arrow = @$el.find ".subanswer-button-arrow"
    up = "fa-angle-up"
    down = "fa-angle-down"
    arrow.removeClass(if enabled then down else up)
    arrow.addClass(if enabled then up else down)


class View.SubquestionList extends Backbone.View
  
  initialize: ->
    @subquestionCollection = @model.get "subquestionCollection"
    @setShowState()
    @render() # Subclass method
    @model.on "change:subquestionsEnabled", => @setShowState()
      
  setShowState: ->
    @show = @model.get "subquestionsEnabled"
    @$el[if @show then "show" else "hide"]()


class View.AreaList extends View.SubquestionList
  
  template: _.tmpl "#area-list-item-tmpl"
    
  render: ->
    @$el.append "Previous area subquestions<br>"
    @areaSubquestionCollection = @model.get "areaSubquestionCollection"
    @areaSubquestionCollection?.each (model) => new View.Area {@el, model}
    #    @subquestionCollection?.each (model) => new View.Area {@el, model}


class View.FarmList extends View.SubquestionList
  
  template: _.tmpl "#farm-list-item-tmpl"
    
  render: ->
    @subquestionCollection?.each (model) => new View.Farm {@el, model}


class View.Subquestion extends Backbone.View
  
  initialize: ->
    # @item set by subclass
    if @headingEl
      @headingEl.append @item
    else
      @$el.append @item
    {@subanswer} = @model.attributes
    @checkbox = @item.find "input"
    @checkbox.prop "checked", @model.applies()
    @checkbox.click (evt) => @change($ evt.target)
    
    @model.on "subanswerToChange", (evt) =>
      {answer} = evt
      @checkbox.prop "checked", answer
      @model.saveAnswer answer
    
  change: (el) ->
    applies = if el.is(":checked") then 1 else 0
    @model.saveAnswer applies


class View.Area extends View.Subquestion
  
  template: _.tmpl "#area-list-item-tmpl"
  
  initialize: ->
    {region, area} = @model.attributes
    @item = $ @template {region, area}  # Superclass appends to container
    super()


class View.Farm extends View.Subquestion
  
  template: _.tmpl "#farm-list-item-tmpl"
  regionHeadingTemplate: _.tmpl "#farm-list-region-heading-tmpl"
  areaHeadingTemplate: _.tmpl "#farm-list-area-heading-tmpl"
  
  initialize: ->
    
    {region, regionId, area, areaId, areaNumber, farm} = @model.attributes
    
    f = []
    name = farm.name
    f.push(name) if name
    description = f.join ", "
    
    regionId = regionId ? 0
    @regionEl = @$el.find "[data-region-id=#{regionId}]"
    if @regionEl.length is 0
      @regionEl = $ @regionHeadingTemplate {regionId, region}
      @$el.append @regionEl
    
    #areaId = areaId ? 0
    if areaId
      @headingEl = @regionEl.find "[data-area-id=#{areaId}]"
      if @headingEl.length is 0
        @headingEl = $ @areaHeadingTemplate {areaId, region, area, areaNumber}
        @regionEl.append @headingEl
    else
      @headingEl = @regionEl
    
    @item = $ @template {description, farm}  # Superclass appends to container
    super()


#----------------------------------------------------------#
#  Answers analysis/reporting
#----------------------------------------------------------#

# Abstract class for View.IndustryAnswerAnalysis and View.UserAnswerAnalysis
class View.AnswerAnalysis extends Backbone.View
  
  mainTemplate: _.tmpl "#checklist-answers-main-tmpl"
  analysisTemplate: null  # Override in subclass
    
  metricView: ["hectares"]
  
  initialize: ->
    
    @question = @model
    @analysis = @question.get "analysis"
    @analysis?.metricView = @metricView[0]
    
    return unless @analysis
    
    @mainView = $ @mainTemplate()
    @$el.append @mainView
    @mainView.show()
    
    @showAnalysis()
    
    @metricHandler()
      
  metricHandler: ->
    
    setView = (b) => @setMetricView?(b.data "view")
    
    buttons = $ ".industry-metric-view"
    setView buttons.find("input:checked")
    buttons.click (evt) => setView $(evt.target).find("input")
  
  setMetricView: (view) ->
    # Can override in subclass
    @analysis?.metricView = view
    
  showAnalysis: ->
    @mainView.find(".answer-analysis").append($ @analysisTemplate(@analysis))
    
  answersButtonContainer: ->
    @mainView?.find ".show-data-button"
  


class View.YesNoAnalysis extends View.AnswerAnalysis
  
  graphTemplate: _.tmpl "#yes-no-answer-graph-tmpl"
  blockTemplate: null
  
  metricNames:
    numGrowers: "Growers"
    numFarms: "Farms"
    hectares: "Hectares"
    production: "Production"
    
  metricView: ["hectares"]
    
  metricUnits:
    numGrowers: "growers"
    numFarms: "farms"
    hectares: "ha"
    production: aqnz.productionUnits
  
  options:
    y: "Yes"
    n: "No"
    na: "n/a"
    none: "No answer"
  
  transpose:
    y: "n"
    n: "y"
  
  showAnalysis: ->
    
    @mainView.show()
    @analysisContainer = @mainView.find ".answer-analysis"
    
    for metric, analysis of @analysis
      continue unless metric in @metricView
      @graph(metric, analysis)
      
  setMetricView: (view) ->
    @metricView = [view]
    @analysisContainer?.empty()
    @showAnalysis()
      
  graph: (metric, analysis) ->
    
    differentYear = aqnz.analysisYear isnt aqnz.year
    analysis.year = if differentYear then aqnz.analysisYear else "&nbsp;"
    analysis.metric = @metricNames[metric]
    
    graphMain  = $ @graphTemplate(analysis)
    @analysisContainer.append(graphMain)
    graph = graphMain.find ".yes-no-answer-graph"
    
    unit = @metricUnits[metric]
    
    @block {graph, analysis, option, unit} for option, optionName of @optionsUsed()
    
  block: (spec) ->
    
    {graph, analysis, option, unit} = spec
    
    value = analysis[option]
    total = analysis.total
    percent = analysis.percent[option]
    
    percentText = if percent>=5 then percent.toFixed(0)+"%" else "&nbsp;"
    
    optionName = @optionName(option)
    optionText = if percent>=10 and option in ["y", "n", "na"] then optionName else "&nbsp;"
    # TODO: issue with margins changing box width
    
    c = @optionTranspose(option)
    optionCls = if percent>30 then "answer-graph-option-text" else "answer-graph-option-narrow-text"
    optionCls += " answer-graph-option-text-transpose" if c is "y" and option is "n"
    blockCls = "answer-block-#{c}"
    
    title = "#{optionName}: #{value.toFixed(0)} of #{total.toFixed(0)} #{unit} (#{percent.toFixed(1)}%)"
    
    heading = @blockHeading option
    userText = @userText option
    
    block = @blockTemplate {
      heading
      value
      total
      percent
      option
      optionName
      unit
      percentText
      optionText
      userText
      cls: blockCls
      optionCls
      title
    }
    graph.append block
  
  optionsUsed: ->
    transpose = @question.get "transpose"
    return @options unless transpose
    options = {}
    for o, name of @options
      t = @transpose[o] ? o
      options[t] = @options[t]
    options
    
  optionName: (o) ->
    @optionsUsed()[o]
  
  optionTranspose: (o) ->
    transpose = @question.get "transpose"
    if transpose then @transpose[o] ? o else o


class View.IndustryYesNoAnalysis extends View.YesNoAnalysis
  
  blockTemplate: _.tmpl "#industry-yes-no-answer-graph-block-tmpl"
  
  metricView: ["hectares"]
  
  blockHeading: -> ""
  
  userText: -> ""
  


class View.UserYesNoAnalysis extends View.YesNoAnalysis
  
  blockTemplate: _.tmpl "#user-yes-no-answer-graph-block-tmpl"
  
  metricView: ["hectares"]
  
  mainViewClasses: ["answer-analysis-row-margin"]
  
  userAnswers:
    y: "yes"
    n: "no"
    na: "n/a"
    none: null
  
  userIcons:
    y: "fa fa-user"  # "fa fa-user-check"
    n: "fa fa-user"  # "fa fa-user-times"
    na: "fa fa-user"  # "fa fa-user-edit"
    none: "fa fa-user"  # "fa fa-user-edit"
    
  showAnalysis: ->
    @mainView.addClass(cls) for cls in @mainViewClasses
    @userAnswer = @question.reportAnswer()
    super()
  
  blockHeading: (o) ->
    if @optionTranspose(o) is "y" then "Industry" else ""
  
  userText: (o) ->
    thisAnswer = @userAnswers[o]
    return "" unless @userAnswer is thisAnswer
    c = @optionTranspose o
    optionName = @optionName(o)
    icon = @userIcons[c]
    title = if thisAnswer then "Your answer: #{optionName}" else "You have not answered this question"
    userCls = "user-answer-icon-#{c}"
    # TODO: template
    userText = "<div class='user-answer-icon #{userCls}'>You<br><i class='fa #{icon}' title='#{title}'></i></div>"
  


class View.GrowerNumberAnalysis extends View.AnswerAnalysis
  
  # Also used for RegionalNumberAnalysis
  
  analysisTemplate: _.tmpl "#regional-number-answer-analysis-tmpl"  # Share template
  
  metricView: ["hectares"]
  
  setMetricView: (view) ->
    @analysis.metricView = view
    @analysisContainer?.empty()
    @showAnalysis()
  
  showAnalysis: ->
    
    #console.log "question/analysis", @question.get("text"), @analysis
    
    @analysisContainer = @mainView.find ".answer-analysis"
    
    differentYear = aqnz.analysisYear isnt aqnz.year
    @analysis.year = if differentYear then aqnz.analysisYear else "&nbsp;"
    
    reportQuestion = @question.get "reportQuestion"
    
    unless reportQuestion?.total?
      super()
      return
    
    # For analysis year
    total = reportQuestion.total
    ha = reportQuestion.farmedHectares
    production = reportQuestion.volumeProduced
    
    if reportQuestion.unit is "%"
      @analysis.growerPerHectare = total  # Average
    else
      @analysis.growerPerHectare = if ha>0 then total/ha else 0
      @analysis.growerPerUnitProduction = if production>0 then total/production else 0
    
    super()
  


#----------------------------------------------------------#
#  Grower checklist answers
#----------------------------------------------------------#

class View.GrowerAnswersButton extends Backbone.View
  
  initialize: ->
    
    @setButton()
    
    @$el?.click =>
      @model.toggleGrowerAnswersVisibility()
      @setButton()
      false
  
  setButton: ->
    show = @model.get "growerAnswersVisible"
    @$el?.text(if show then "Hide answers" else "Show answers")
  


class View.GrowerAnswers extends Backbone.View
  
  answersTemplate: _.tmpl "#checklist-grower-answers-tmpl"
  answerTemplate: _.tmpl "#checklist-grower-answer-tmpl"
  
  initialize: ->
    
    @question = @model
    @answers = @question.get "growerAnswers"
    return unless @answers
    
    @answersContainer = $ @answersTemplate({})
    @$el.append @answersContainer
    @setChecklistAnswers()
    @showChecklistAnswers()
    
    @model.on "change:growerAnswersVisible", => @showChecklistAnswers()
    
  setChecklistAnswers: ->
    @answers?.each (ans) =>
      {grower, checklistId, answer} = ans.attributes
      return unless answer
      @answersContainer.append @answerTemplate
        description: grower.name
        link: "/checklist/#{checklistId}"
        answer: @formatAnswer(answer)
        
  showChecklistAnswers: ->
    show = @model.get "growerAnswersVisible"
    @answersContainer[if show then "show" else "hide"]()
    false
    
  # Override in subclass - for answers list
  formatAnswer: (answer) -> answer


class View.YesNoAnswers extends View.GrowerAnswers
  
  formatAnswer: (answer) ->
    answer


class View.RegionalNumberAnswers extends View.GrowerAnswers
  
  #analysisTemplate: _.tmpl "#regional-number-answer-analysis-tmpl"
  
  formatAnswer: (answer) ->
    a = @numbersToString(answer)
    
  numbersToString: (numbers) ->
    try
      x = JSON.parse(numbers)
      if typeof x is "object"
        return ("#{p} #{v}" for p, v of x).join ", "
      else
        return x
    catch
      return numbers


class View.FileAnswers extends View.GrowerAnswers
  
  formatAnswer: (answer) ->
    n = answer.split(",").length
    "#{n} file#{if n>1 then 's' else ''}"
  


# Dup code - see growers view.coffee

tonnes = (x) ->
  return "" if x<=0
  round = Math.round
  d = if x<100 then round(10*x)/10 else round(x)
  "#{numberFormat(d)} tonne#{if d is 1 then '' else 's'}"

dozens = (x) ->
  return "" if x<=0
  round = Math.round
  d = parseFloat(if x<100 then round(10*x)/10 else round(x))
  "#{numberFormat(d)} dozen"

numberFormat = (v) ->
  "#{v.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}"


# class View.CleanupReport extends View.RegionalNumberAnalysis
#
#   template: _.tmpl "#clean-up-report-tmpl"
#
#   # Override in subclass
#   showAnalysis: ->
#
#     return unless @analysis
#
#     @mainView.show()
#     @analysisContainer = @mainView.find ".answer-analysis"
#
#     # Cleanups per 100ha - TODO model?
#     @industryResult = 100*@analysis.perHectare
#
#
#
#
# class View.IndustryCleanupReport extends View.CleanupReport
#
#   showAnalysis: ->
#
#     super()
#
#
#
# class View.UserCleanupReport extends View.CleanupReport
#
#   showAnalysis: ->
#
#     super()
#
#     answerModel = @question.get("answerModel")
#     userTotal = answerModel.total()
#     @userResult = 100*userTotal/aqnz.hectaresFarmed  # TODO better way?
#
#     console.log "industry/user", @industryResult, @userResult
#
#     graph = @template {
#       @industryResult
#       @userResult
#     }
#     @analysisContainer.append graph
  
